import { render, staticRenderFns } from "./BoardAdvertising.vue?vue&type=template&id=dab6f294&scoped=true&"
import script from "./BoardAdvertising.vue?vue&type=script&lang=js&"
export * from "./BoardAdvertising.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab6f294",
  null
  
)

export default component.exports